<div *ngIf="showSpinner" class="loader" [ngClass]="[sizeClass, colorClass]">
  <div class="loader-inner"></div>
</div>
